import { defineStore } from 'pinia'

export const supportedLocales = ['en', 'de', 'fr'] as const
export type Locale = (typeof supportedLocales)[number]

const detectInitialLocale = (): Locale => {
  // Use browser language as the default. If the user has an explicit
  // preferred_language saved on the backend, fetchUser() will override this.
  const navigatorLocale = (navigator.language || navigator.languages[0]) as string
  console.debug('[localeStore] detectInitialLocale — navigator.language:', navigatorLocale)

  if (supportedLocales.includes(navigatorLocale as Locale)) {
    console.debug('[localeStore] using navigator.language:', navigatorLocale)
    return navigatorLocale as Locale
  }

  const baseLocale = navigatorLocale.split('-')[0]
  if (supportedLocales.includes(baseLocale as Locale)) {
    console.debug('[localeStore] using navigator base locale:', baseLocale)
    return baseLocale as Locale
  }

  console.debug('[localeStore] falling back to de')
  return 'de' // Fallback to German to match the backend default (LANGUAGE_CODE)
}

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    locale: detectInitialLocale()
  }),

  actions: {
    setLocale(newLocale: Locale) {
      console.debug('[localeStore] setLocale:', this.locale, '→', newLocale)
      this.locale = newLocale
    }
  },

  getters: {
    getLocale(state): Locale {
      return state.locale
    }
  }
})
